module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dUCz0"))).then(() => parcelRequire('d0iPb'));